"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _useStyleToEmotionObject = _interopRequireDefault(require("../hooks/internal/useStyleToEmotionObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: [P3] Although this is for development purpose, prettify it
var ROOT_STYLE = {
  color: 'Red',
  margin: 0
};

var SayAlt = function SayAlt(_ref) {
  var speak = _ref.speak;
  var rootClassName = (0, _useStyleToEmotionObject.default)()(ROOT_STYLE) + '';
  return !!speak && /*#__PURE__*/_react.default.createElement("pre", {
    className: rootClassName
  }, speak);
};

SayAlt.defaultProps = {
  speak: ''
};
SayAlt.propTypes = {
  speak: _propTypes.default.string
};
var _default = SayAlt;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJST09UX1NUWUxFIiwiY29sb3IiLCJtYXJnaW4iLCJTYXlBbHQiLCJzcGVhayIsInJvb3RDbGFzc05hbWUiLCJ1c2VTdHlsZVRvRW1vdGlvbk9iamVjdCIsImRlZmF1bHRQcm9wcyIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsInN0cmluZyJdLCJzb3VyY2VSb290IjoiY29tcG9uZW50Oi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL0FjdGl2aXR5L1NheUFsdC5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0JztcblxuaW1wb3J0IHVzZVN0eWxlVG9FbW90aW9uT2JqZWN0IGZyb20gJy4uL2hvb2tzL2ludGVybmFsL3VzZVN0eWxlVG9FbW90aW9uT2JqZWN0JztcblxuLy8gVE9ETzogW1AzXSBBbHRob3VnaCB0aGlzIGlzIGZvciBkZXZlbG9wbWVudCBwdXJwb3NlLCBwcmV0dGlmeSBpdFxuY29uc3QgUk9PVF9TVFlMRSA9IHtcbiAgY29sb3I6ICdSZWQnLFxuICBtYXJnaW46IDBcbn07XG5cbmNvbnN0IFNheUFsdCA9ICh7IHNwZWFrIH0pID0+IHtcbiAgY29uc3Qgcm9vdENsYXNzTmFtZSA9IHVzZVN0eWxlVG9FbW90aW9uT2JqZWN0KCkoUk9PVF9TVFlMRSkgKyAnJztcblxuICByZXR1cm4gISFzcGVhayAmJiA8cHJlIGNsYXNzTmFtZT17cm9vdENsYXNzTmFtZX0+e3NwZWFrfTwvcHJlPjtcbn07XG5cblNheUFsdC5kZWZhdWx0UHJvcHMgPSB7XG4gIHNwZWFrOiAnJ1xufTtcblxuU2F5QWx0LnByb3BUeXBlcyA9IHtcbiAgc3BlYWs6IFByb3BUeXBlcy5zdHJpbmdcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFNheUFsdDtcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOztBQUNBOztBQUVBOzs7O0FBRUE7QUFDQSxJQUFNQSxVQUFVLEdBQUc7RUFDakJDLEtBQUssRUFBRSxLQURVO0VBRWpCQyxNQUFNLEVBQUU7QUFGUyxDQUFuQjs7QUFLQSxJQUFNQyxNQUFNLEdBQUcsU0FBVEEsTUFBUyxPQUFlO0VBQUEsSUFBWkMsS0FBWSxRQUFaQSxLQUFZO0VBQzVCLElBQU1DLGFBQWEsR0FBRyxJQUFBQyxnQ0FBQSxJQUEwQk4sVUFBMUIsSUFBd0MsRUFBOUQ7RUFFQSxPQUFPLENBQUMsQ0FBQ0ksS0FBRixpQkFBVztJQUFLLFNBQVMsRUFBRUM7RUFBaEIsR0FBZ0NELEtBQWhDLENBQWxCO0FBQ0QsQ0FKRDs7QUFNQUQsTUFBTSxDQUFDSSxZQUFQLEdBQXNCO0VBQ3BCSCxLQUFLLEVBQUU7QUFEYSxDQUF0QjtBQUlBRCxNQUFNLENBQUNLLFNBQVAsR0FBbUI7RUFDakJKLEtBQUssRUFBRUssa0JBQUEsQ0FBVUM7QUFEQSxDQUFuQjtlQUllUCxNIn0=